import { Container, Row, Col, Card, Form } from 'react-bootstrap';
import { useTheme } from '@/contexts/ThemeContext';

export function SettingsPage() {
    const { theme, setTheme } = useTheme();

    return (
        <Container className="p-4">
            <h1 className="h3 mb-4">Settings</h1>

            <Row>
                <Col md={8} lg={6}>
                    <Card className="shadow-sm">
                        <Card.Header className="bg-body-secondary">
                            <h2 className="h5 mb-0">Appearance</h2>
                        </Card.Header>
                        <Card.Body>
                            <Form.Group>
                                <Form.Label>Theme</Form.Label>
                                <Form.Select
                                    value={theme}
                                    onChange={(e) => setTheme(e.target.value as any)}
                                >
                                    <option value="light">Light</option>
                                    <option value="dark">Dark</option>
                                    <option value="auto">System (Auto)</option>
                                </Form.Select>
                                <Form.Text className="text-muted">
                                    Choose your preferred color theme.
                                </Form.Text>
                            </Form.Group>
                        </Card.Body>
                    </Card>

                    <Card className="mt-4 shadow-sm">
                        <Card.Header className="bg-body-secondary">
                            <h2 className="h5 mb-0">About</h2>
                        </Card.Header>
                        <Card.Body>
                            <p className="mb-1"><strong>PlaylistR</strong> v1.0.0</p>
                            <p className="text-muted small">Built with React, Firebase, and TypeScript.</p>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </Container>
    );
}
